/**
 * Thẻ "Chuẩn bị tiệm" — bốn bước đúng điều kiện NHẬN LỊCH THẬT (kế hoạch san-sang-thi-truong-2026-10, 1.3).
 * Hàm thuần, có test (`chuan-bi-tiem.test.ts`). Dữ liệu đến từ `GET /v1/admin/chuan-bi-tiem`.
 *
 * Bước 4 phụ thuộc cờ Live (1.5): ứng dụng đặt lịch trên Zalo chưa chạy thật thì không có "Mã QR cho khách" —
 * bước cuối là đặt thử một lịch ở quầy.
 *
 * Nguyên tắc (ADR-118, chủ dự án 26/10): MỘT VIỆC ĐÃ LÀM ĐƯỢC THÌ PHẢI ĐƯỢC TÍNH XONG — thẻ không bắt chủ tiệm làm thêm
 * việc thừa khi dữ liệu mặc định đã đủ:
 *   - Bước 2 "Dịch vụ và giá" XONG khi có ít nhất một dịch vụ đang bán. Giá còn là giá mẫu chỉ đổi câu gợi ý ("sửa
 *     khi cần"), KHÔNG giữ thẻ lại (bản vòng sửa UX Đợt 1 từng bắt sửa giá mới xong → tiệm có 5 dịch vụ mẫu vẫn bị hỏi tiếp).
 *   - Bước "Mã QR cho khách" XONG khi chủ đã mở tờ QR trên máy này (`daMoQr`, `da-mo-ma-qr.ts`) hoặc đã có lịch bất kỳ
 *     (quầy hay Zalo) — không đợi khách đầu tiên (tiệm mới chưa có khách thì không bao giờ qua được).
 * Tiệm mới mở chỉ còn việc thật: xếp ca cho nhân viên (tiệm 1 người: chủ nhận khách ngay) và mở tờ QR.
 */

export interface TinhTrangChuanBi {
  /** Có chi nhánh đang dùng với giờ mở cửa. */
  gioMoCua: boolean
  /** Có ít nhất một dịch vụ đang bán. */
  dichVu: boolean
  /** Mọi dịch vụ đang bán còn đúng tên + giá mẫu của ngành. */
  giaMau: boolean
  /** Có người đang làm vừa làm được dịch vụ vừa có ca trong 7 ngày tới. */
  nguoiNhanKhach: boolean
  /** Có lịch không phải nháp. */
  coLich: boolean
  /** Có lịch khách tự đặt qua ứng dụng trên Zalo. */
  coLichZalo: boolean
}

export type MaBuocChuanBi = 'gio-mo-cua' | 'dich-vu' | 'nguoi-nhan-khach' | 'ma-qr' | 'dat-thu'

export interface BuocChuanBi {
  ma: MaBuocChuanBi
  xong: boolean
  /** Chỉ bước "dich-vu": có dịch vụ nhưng giá còn là giá mẫu (chỉ đổi câu gợi ý; bước này VẪN xong). */
  giaMau: boolean
}

/**
 * @param daMoQr Chủ đã mở tờ "Mã QR cho khách" trên máy này (chỉ có nghĩa khi `live`: chưa Live thì không có QR để mở).
 */
export function buocChuanBi(tt: TinhTrangChuanBi, live: boolean, daMoQr = false): BuocChuanBi[] {
  return [
    { ma: 'gio-mo-cua', xong: tt.gioMoCua, giaMau: false },
    { ma: 'dich-vu', xong: tt.dichVu, giaMau: tt.dichVu && tt.giaMau },
    { ma: 'nguoi-nhan-khach', xong: tt.nguoiNhanKhach, giaMau: false },
    live
      ? { ma: 'ma-qr', xong: daMoQr || tt.coLich, giaMau: false }
      : { ma: 'dat-thu', xong: tt.coLich, giaMau: false },
  ]
}

/** Thẻ CHỈ ẩn khi đủ cả 4 bước THẬT (bước 4 theo cờ Live; giá mẫu KHÔNG giữ thẻ). */
export function theChuanBiConHien(tt: TinhTrangChuanBi, live: boolean, daMoQr = false): boolean {
  return buocChuanBi(tt, live, daMoQr).some((b) => !b.xong)
}
